import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  createFilterOptions,
  Divider,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Clear } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../dataConfig";
import { toast } from "react-toastify";
import ErrorProps from "../../../Component/Errorprops";

const TechnicalSpecModal = ({ mode, handleCloseClick, editData }) => {
  const [component, setComponent] = useState([]);
  const [inputValue, setInputValue] = useState(
    mode === "Edit" ? editData?.componentName : ""
  );
  const [technicalType, setTechnicalType] = useState([])
  const [loading, setLoading] = useState(false)

  const OPTIONS_LIMIT = 10;
  const defaultFilterOptions = createFilterOptions();

  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };

  useEffect(() => {
    getData()
  }, []);

  const getData = async () => {
    setLoading(true)
    const link = masterAPI["component"].link;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        setLoading(false)
        setComponent(res.data.result);
      })
      .catch((e) => {
        setLoading(false)
        setComponent([])
      });
    const typelink = masterAPI["selectList"].technicalSpecificationType
    await axiosPrivate
      .get(`${typelink}`)
      .then((res) => {
        setLoading(false)
        console.log(res)
        setTechnicalType(res.data);
      })
      .catch((e) => {
        setLoading(false)
        setTechnicalType([])
        if (e.response.data.FailureMessage) {
          toast.error("Code is already exists")
        }
        console.log(e, "create technicalSpecificationType");
      });

  }

  const initialValue = {
    techSpecName: mode === "Edit" ? editData.techSpecName : "",
    technicalSpecificationType: mode === "Edit" ? editData.technicalSpecificationType : "",
    // parentTechId:mode==="Edit"?editData.parentTechId: null,
    code: mode === "Edit" ? editData.code : "",
    componentProfileId: mode === "Edit" ? editData.componentProfileId : "",
  };
  const validationSchema = Yup.object().shape({

    code: Yup.string().required("Code is required"),
    techSpecName: Yup.string().required("Name is required"),
    technicalSpecificationType: Yup.string().required("Technical Sepecification Type is required"),
    componentProfileId: Yup.string().required("Component Profile is required"),
  });
  const onSubmit = async (value) => {
    console.log(value);
    setLoading(true)
    const createLink = masterAPI["technicalSpecification"].create;
    const updateLink = masterAPI["technicalSpecification"].update
    if (mode === "Create") {
      await axiosPrivate.post(`${createLink}`, value).then(res => {
        console.log(res.data)
        setLoading(false)
        handleCloseClick()
      }).catch(e => {
        setLoading(false)
        console.log(e, "createtechnicalSpecification")
      })
    } else {
      const updateAC = {
        id: editData.id,
        ...value
      }
      await axiosPrivate.put(`${updateLink}`, updateAC).then(res => {
        console.log(res.data)
        setLoading(false)
        handleCloseClick()
      }).catch(e => {
        setLoading(false)
        console.log(e, "updatetechnicalSpecification")
      })
    }

  };

  const handleCancel = () => {
    handleCloseClick();
  };

  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {mode === "Edit" ? editData.code + "-" + editData.techSpecName : "New Technical Specification"}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik initialValues={initialValue} validationSchema={validationSchema} onSubmit={onSubmit}>
        {({ handleChange, setFieldValue, values, resetForm }) => (
          <Form>
            <Grid container spacing={"1rem"}>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Technical Specification Code
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="code"
                  placeholder="Enter Tech Specification Code"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                <ErrorMessage name="code">
                  {(error) => <ErrorProps>{error}</ErrorProps>}
                </ErrorMessage>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Technical Specification Name
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="techSpecName"
                  placeholder="Enter Tech Specification Name"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                <ErrorMessage name="techSpecName">
                  {(error) => <ErrorProps>{error}</ErrorProps>}
                </ErrorMessage>
              </Grid>
              {/* <Grid item xs={12} md={6}>
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                 Parent Technical Specification
                </Typography>
              <Field
                as={Select}
                // label={"Select"}
                size={"small"}
                type="text"
                name="parentTechId"
                // placeholder="Enter Asset Category Name"
                fullWidth
                displayEmpty
                MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
               renderValue={values.parentTechId !== null ? undefined : () =><Typography sx={{  color: color.placeholderColor,
                fontSize: "13px",}} >Select</Typography> }
              >
               
                {parentId.map((id, i) => (
                  <MenuItem value={id.id} disabled={editData.id===id.id&&mode==="Edit"}>{id.code+" - "+id.techSpecName}</MenuItem>
                ))}
            
              </Field>
            </Grid> */}
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Technical Specification Type
                </Typography>
                <Field
                  as={Select}
                  // label={"Select"}
                  size={"small"}
                  type="text"
                  name="technicalSpecificationType"
                  // placeholder="Enter Asset Category Name"
                  fullWidth
                  displayEmpty
                  MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
                  renderValue={values.technicalSpecificationType !== "" ? undefined : () => <Typography sx={{
                    color: color.placeholderColor,
                    fontSize: "13px",
                  }} >Select</Typography>}
                >

                  {technicalType.map((id, i) => (
                    <MenuItem value={id.value}>{id.text}</MenuItem>
                  ))}

                </Field>
                <ErrorMessage name="technicalSpecificationType">
                  {(error) => <ErrorProps>{error}</ErrorProps>}
                </ErrorMessage>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Component
                </Typography>
                <Autocomplete
                  // value={remedySelect}
                  inputValue={inputValue}
                  //value={causeInfo.id===null?null:causeInfo}
                  fullWidth
                  filterOptions={filterOptions}
                  loading={component.length}
                  options={component}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) =>
                    option.code + "-" + option.componentName
                  }
                  freeSolo
                  onChange={(event, value) => {
                    console.log(value);
                    if (value !== null) {
                      setFieldValue("componentProfileId", value.id);
                    } else {
                      setFieldValue("componentProfileId", "");
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="componentProfileId"
                      placeholder="Select Component"
                      //  onChange={handleChange}
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                            {component.length === 0 ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
                <ErrorMessage name="componentProfileId">
                  {(error) => <ErrorProps>{error}</ErrorProps>}
                </ErrorMessage>
              </Grid>
              <Grid container item xs={12} justifyContent={"flex-end"} gap="1rem">
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  sx={{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                    ":hover": {
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                    }
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type={"submit"}
                  variant="contained"
                  disabled={loading}
                  sx={{

                    textTransform: "none",
                    backgroundColor: loading ? "default" : color.TableButtonColor,
                    "&:hover": {
                      backgroundColor: loading
                        ? "default"
                        : color.buttonDisable,
                    },
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default TechnicalSpecModal;
